import React from 'react';
import { classNames } from '../../utils/style';
import { applyBgColor } from '../../utils/utils';
import { PayFitColor } from '../../types/module';
import { Image } from '../../components/Image';
import { ImageProps } from '../../components/Image/types';
import { fontHeading2, fontBody } from '../../styles/typographyNew';
export interface ImageBlockProps {
  title: string;
  subtitle: string;
  image: ImageProps;
  backgroundColor?: PayFitColor;
  isDark?: boolean;
  className?: string;
}

export const ImageBlock = ({
  title,
  subtitle,
  image,
  backgroundColor = 'blue',
  isDark = false,
  className = '',
}: ImageBlockProps) => {
  return (
    <div
      className={classNames(
        'ImageBlock',
        'flex flex-col gap-[40px]',
        className,
        applyBgColor(backgroundColor, isDark),
      )}
    >
      {(title || subtitle) && (
        <div className="mx-auto flex max-w-[800px] flex-col gap-8">
          {title && (
            <h2 className={classNames(fontHeading2, 'text-center')}>{title}</h2>
          )}
          {subtitle && (
            <p className={classNames(fontBody, 'text-center text-[#4E6176]')}>
              {subtitle}
            </p>
          )}
        </div>
      )}
      <Image
        {...image}
        pixelDensity="image_with_text"
        className="h-full w-full rounded-12 md:rounded-18 lg:rounded-[24px]"
        sizes={[
          '(max-width: 350px) 286px',
          '(max-width: 768px) 703px',
          '(max-width: 1024px) 740px',
          '1202px',
        ]}
      />
    </div>
  );
};
